import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {PullRequestActiveRoute} from '../hooks/use-active-route'

export interface PullRequestRouteConfig {
  /** Whether the layout should use full-width (files/changes/checks) or condensed (conversation/overview/commits). */
  layout: 'full-width' | 'condensed'
  /** Whether the docked side panel is supported on this route. */
  dockedPanelSupported: boolean
}

function buildRouteConfigs(): Record<PullRequestActiveRoute, PullRequestRouteConfig> {
  const updatedHeader = isFeatureEnabled('updated_pull_request_header')

  return {
    overview: {
      layout: updatedHeader ? 'full-width' : 'condensed',
      dockedPanelSupported: updatedHeader,
    },
    conversation: {
      layout: updatedHeader ? 'full-width' : 'condensed',
      dockedPanelSupported: updatedHeader,
    },
    files_changed: {
      layout: 'full-width',
      dockedPanelSupported: true,
    },
    commits: {
      layout: updatedHeader ? 'full-width' : 'condensed',
      dockedPanelSupported: updatedHeader,
    },
    checks: {
      layout: 'full-width',
      dockedPanelSupported: updatedHeader,
    },
    findings: {
      layout: updatedHeader ? 'full-width' : 'condensed',
      dockedPanelSupported: false,
    },
    walkthrough: {
      layout: 'full-width',
      dockedPanelSupported: false,
    },
  }
}

export function getRouteConfig(activeRoute: PullRequestActiveRoute): PullRequestRouteConfig {
  return buildRouteConfigs()[activeRoute]
}
